import { render, staticRenderFns } from "./ProductMaterialCost.vue?vue&type=template&id=418847f9&"
import script from "./ProductMaterialCost.vue?vue&type=script&lang=js&"
export * from "./ProductMaterialCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports